import React from "react";
import { Heart } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";
import { toast } from "sonner";

export default function FavoriteButton({ slug, size = "md", floating = true }) {
  const { isFavorite, toggle } = useFavorites();
  const active = isFavorite(slug);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(slug);
    if (!active) toast.success("Adicionado aos favoritos");
    else toast("Removido dos favoritos");
  };

  const sz = size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const icon = size === "lg" ? "h-5 w-5" : "h-4 w-4";
  const cls = floating
    ? `absolute top-3 right-3 z-10 ${sz} inline-flex items-center justify-center rounded-full bg-white/95 shadow-md backdrop-blur transition-transform hover:scale-110 active:scale-95`
    : `${sz} inline-flex items-center justify-center rounded-full border border-stone-200 bg-white transition-colors hover:border-[#103C4A]`;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={active ? "Remover dos favoritos" : "Adicionar aos favoritos"}
      aria-pressed={active}
      data-testid={`favorite-button-${slug}`}
      className={cls}
    >
      <Heart className={`${icon} transition-colors ${active ? "fill-[#103C4A] text-[#103C4A]" : "text-stone-600"}`} />
    </button>
  );
}
